export default __webpack_public_path__ + "static/infinix-preorder-5ed80f4224ba92507bee71cde97b2e0c.webp";